<template>
  <div>

  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'MyHome',
  setup() {
    return {

    }
  }
}

</script>
